import { defineStore, storeToRefs } from "pinia";
import { ref, reactive } from "vue";
import { USER_ROLES } from "../lib/enums";
import { useBoothsStore } from "../stores/booths";
import {
  updateUser,
  userConfirmEmail,
  userLogin,
  userLogout,
  userMe,
} from "../lib/endpoints";

import { verifyToken } from "../lib/endpoints_rainfocus";

export const useUsersStore = defineStore("users", () => {
  const boothsStore = useBoothsStore();
  const user = reactive({
    name: "",
    email: "",
    id: "",
    roles: [],
    events: [],
    isLoggedIn: false,
  });

  const roles = ref([]);
  const account = ref(null);
  const exhibitorAccount = ref(null);

  const { fetchEvent } = boothsStore;
  const { requestingBoothsIds, event } = storeToRefs(boothsStore);

  function is(roleId) {
    return roles.value.includes(roleId);
  }

  function isAdmin() {
    return is(USER_ROLES.ADMINS);
  }

  async function getSessionInfo() {
    if (user.isLoggedIn) {
      return user;
    } else {
      const profile = await me();
      return profile;
    }
  }

  async function getTokenInfo(eventId, exhibitorId) {
    try {
      await fetchEvent(eventId);

      const exhibitorData = await verifyToken(
        event.value.rfApiProfileId,
        exhibitorId,
      );
      // console.log("verify token?", event, exhibitorData);
      const exhibitor = exhibitorData.data;
      const level =
        exhibitor.attributeValues.find(
          (it) => it.attribute === "Exhibitor Type",
        )?.value || "";
      const assignedBoooth =
        exhibitor.booth && exhibitor.booth.length > 0 && exhibitor.booth[0];

      if (exhibitor.reservation) {
        requestingBoothsIds.value = exhibitor.reservation.boothIds;
      } else {
        requestingBoothsIds.value = [];
      }

      exhibitorAccount.value = {
        exhibitorId: exhibitor.exhibitorId,
        name: exhibitor.name,
        level,
        code: exhibitorId,
        assignedBoooth,
      };
      // console.log({ exhibitorAccount });

      roles.value = [USER_ROLES.SPONSORS];
    } catch (_error) {
      console.error("getTokenInfo error", _error.message);
    }
  }

  async function handleVisitor({ eventId, level }) {
    await fetchEvent(eventId);
    exhibitorAccount.value = {
      exhibitorId: null,
      name: null,
      level,
      token: null,
    };
    roles.value = [USER_ROLES.VISITORS];
  }

  async function login(email, password) {
    let data = await userLogin(email, password);
    // Assign values to user properties directly
    user.name = data.name;
    user.email = data.email;
    user.id = data.id;
    user.roles = data.roles;
    user.events = data.events;
    user.isLoggedIn = true;

    roles.value = data.roles;

    return user;
  }

  async function firstLogin(email, password, token) {
    try {
      await userConfirmEmail(token);
    } catch (error) {
      console.error("firstLogin error", error.message);
    } finally {
      const user = await userLogin(email, "oqFASF$A8o27rtxnWFGIO(DS");
      await updateUser(user.id, {
        password,
      });
    }
  }

  async function isLoggedIn() {
    return user.isLoggedIn;
  }

  async function logout() {
    await userLogout();
    user.isLoggedIn = false;
    roles.value = [];
    account.value = null;
    exhibitorAccount.value = null;
  }

  async function me() {
    const data = await userMe();
    if (data == null) {
      return false;
    } else {
      // Assign values to user properties directly
      user.name = data.name;
      user.email = data.email;
      user.id = data.id;
      user.roles = data.roles;
      user.isLoggedIn = true;

      roles.value = data.roles;
      return user;
    }
  }

  return {
    roles,
    account,
    exhibitorAccount,
    is,
    isAdmin,
    getSessionInfo,
    getTokenInfo,
    logout,
    login,
    firstLogin,
    handleVisitor,
    user,
  };
});
